var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "uploadBox" }, [
    _vm.use_for_form
      ? _c("div", { staticClass: "selected-images--preview" }, [
          _c("h2", { staticClass: "h2-responsive" }, [
            _vm._v(
              "\n\n            " +
                _vm._s(_vm.use_for_form.selected_images.length) +
                " " +
                _vm._s(
                  _vm.pluralise(
                    "Image",
                    _vm.use_for_form.selected_images.length
                  )
                ) +
                "\n            selected\n\n        "
            )
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            _vm._l(_vm.use_for_form.selected_images, function(
              list_image,
              index
            ) {
              return _c(
                "div",
                {
                  class: _vm.gallery.thumbnail_class,
                  on: {
                    click: function($event) {
                      _vm.toggleSelected(list_image)
                    }
                  }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: list_image.table_id,
                        expression: "list_image.table_id"
                      }
                    ],
                    attrs: {
                      type: "hidden",
                      name: _vm.use_for_form.selected_images_name
                    },
                    domProps: { value: list_image.table_id },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(list_image, "table_id", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "figure",
                    {
                      staticClass: "btn btn-primary gallery-image",
                      class: { "gallery-image--main": index <= 0 }
                    },
                    [
                      _c(
                        "picture",
                        {
                          staticClass:
                            "img-thumbnail gallery-image---thumbnail",
                          class: { active: list_image.active },
                          attrs: {
                            id: list_image.id,
                            "data-ref": "thumbnail-preview"
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "img-fluid",
                            attrs: {
                              srcset: list_image.src,
                              alt: list_image.title
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("figcaption", [
                        _c("h5", { staticClass: "h5-responsive" }, [
                          _vm._v(_vm._s(list_image.title))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "gallery-image--tags" },
                          _vm._l(list_image.tags, function(tag, index) {
                            return _c("span", [
                              _c(
                                "span",
                                { staticClass: "gallery-image--tag" },
                                [_vm._v(_vm._s(tag))]
                              ),
                              _vm._v(" "),
                              index + 1 < list_image.tags.length
                                ? _c("span", [_vm._v(", ")])
                                : _vm._e()
                            ])
                          })
                        )
                      ])
                    ]
                  )
                ]
              )
            })
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "ul",
      {
        staticClass: "nav nav-tabs nav-justified",
        attrs: { id: "images_finder" }
      },
      [
        _c("li", { staticClass: "nav-item" }, [
          _c(
            "a",
            {
              class: _vm.gallery.tabs.gallery.controller.classes,
              attrs: { href: "#", role: "tab" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.toggleTabs("gallery")
                }
              }
            },
            [_c("i", { staticClass: "fa fa-image" }), _vm._v(" Gallery")]
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "nav-item" }, [
          _c(
            "a",
            {
              class: _vm.gallery.tabs.uploader.controller.classes,
              attrs: { href: "#", role: "tab" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.toggleTabs("uploader")
                }
              }
            },
            [_c("i", { staticClass: "fa fa-plus" }), _vm._v(" Add")]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "tab-content" }, [
      _c(
        "div",
        {
          class: _vm.gallery.tabs.gallery.content.classes,
          attrs: { role: "tabpanel" }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 pl-0 pr-0" }, [
              _c(
                "div",
                { attrs: { id: "material_select--wrapper" } },
                [
                  _c("material-select", {
                    ref: "image_tag_select",
                    attrs: { id: _vm.gallery.select.id },
                    on: {
                      material_select_result: _vm.materialSelectItemSelected
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row gallery-container" },
            _vm._l(_vm.list_images, function(list_image) {
              return _c(
                "div",
                {
                  staticClass:
                    "gallery-image--gallery col-12 col-sm-6 col-md-4 mb-2 ",
                  class: { active: list_image.active },
                  on: {
                    click: function($event) {
                      _vm.toggleSelected(list_image)
                    }
                  }
                },
                [
                  _c(
                    "figure",
                    { staticClass: "btn btn-primary gallery-image" },
                    [
                      _c(
                        "picture",
                        {
                          staticClass:
                            "img-thumbnail gallery-image---thumbnail",
                          class: { active: list_image.active },
                          attrs: { id: list_image.id }
                        },
                        [
                          _c("img", {
                            staticClass: "img-fluid",
                            attrs: {
                              srcset: list_image.src,
                              alt: list_image.title
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("figcaption", [
                        _c("h5", { staticClass: "h5-responsive" }, [
                          _vm._v(_vm._s(list_image.title))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "gallery-image--tags" },
                          _vm._l(list_image.tags, function(tag, index) {
                            return _c("span", [
                              _c(
                                "span",
                                { staticClass: "gallery-image--tag" },
                                [_vm._v(_vm._s(tag))]
                              ),
                              _vm._v(" "),
                              index + 1 < list_image.tags.length
                                ? _c("span", [_vm._v(", ")])
                                : _vm._e()
                            ])
                          })
                        )
                      ])
                    ]
                  )
                ]
              )
            })
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.gallery.tabs.uploader.content.classes,
          attrs: { id: "addItem", role: "tabpanel" }
        },
        [
          _c(
            "form",
            {
              attrs: { role: "form", enctype: "multipart/form-data" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.onUpload($event)
                }
              }
            },
            [
              !_vm.itemsAdded
                ? _c("div", { staticClass: "uploadBoxMain" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        {
                          staticClass: "dropArea",
                          on: { ondragover: _vm.onImageInsert }
                        },
                        [
                          _vm._v(
                            "\n                            Drop multiple files here.\n                            "
                          ),
                          _c("input", {
                            attrs: {
                              type: "file",
                              id: "items",
                              name: "items[]",
                              required: "",
                              multiple: ""
                            },
                            on: { change: _vm.onImageInsert }
                          })
                        ]
                      )
                    ])
                  ])
                : _c("div", { staticClass: "uploadBoxMain" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-12" },
                        _vm._l(_vm.itemsNames, function(image_data) {
                          return _c("div", [
                            _c("div", { staticClass: "row mt-4" }, [
                              _c("div", { staticClass: "col-sm-8" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "row",
                                    attrs: { "data-ref": "Image details" }
                                  },
                                  [
                                    _c("div", { staticClass: "col-sm-12" }, [
                                      _c("div", [
                                        _vm._v(
                                          "\n                                                    " +
                                            _vm._s(image_data.meta.name.value) +
                                            " - " +
                                            _vm._s(image_data.size) +
                                            "\n                                                "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        attrs: {
                                          type: "hidden",
                                          disabled: "",
                                          id: image_data.meta.name.id
                                        },
                                        domProps: {
                                          value: image_data.meta.name.value
                                        }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    image_data.size_raw > _vm.fileSizeLimit
                                      ? _c(
                                          "div",
                                          { staticClass: "col-sm-12" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-danger alert alert-danger",
                                                attrs: { role: "alert" }
                                              },
                                              [
                                                _c(
                                                  "h3",
                                                  { staticClass: "px-0" },
                                                  [
                                                    _vm._v(
                                                      "Image file size too big. Max size is\n                                                        " +
                                                        _vm._s(
                                                          _vm.fileSizeLimit
                                                        ) +
                                                        "M"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    "Reduce image file size before uploading"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    "This image will not be uploaded"
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm.wrongRatio(image_data)
                                        ? _c(
                                            "div",
                                            { staticClass: "col-sm-12" },
                                            [_vm._m(1, true)]
                                          )
                                        : [
                                            _c(
                                              "div",
                                              { staticClass: "col-sm-12" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "md-form form-sm"
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-font prefix"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        id:
                                                          image_data.meta.title
                                                            .id,
                                                        type: "text",
                                                        disabled:
                                                          image_data.size_raw >
                                                          _vm.fileSizeLimit
                                                      },
                                                      domProps: {
                                                        value:
                                                          image_data.meta.title
                                                            .value
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          _vm.updateMetaModel(
                                                            $event.srcElement
                                                              .value,
                                                            image_data.id,
                                                            "title",
                                                            "id"
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass: "active",
                                                        attrs: {
                                                          for:
                                                            image_data.meta
                                                              .title.id
                                                        }
                                                      },
                                                      [_vm._v("Title")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-sm-12" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "md-form form-sm"
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-tags prefix"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.tagModels[
                                                              image_data.value
                                                            ],
                                                          expression:
                                                            "tagModels[image_data.value]"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        type: "text",
                                                        autocomplete: "off",
                                                        id:
                                                          image_data.value +
                                                          "_tags"
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.tagModels[
                                                            image_data.value
                                                          ]
                                                      },
                                                      on: {
                                                        input: [
                                                          function($event) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              _vm.tagModels,
                                                              image_data.value,
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                          function($event) {
                                                            _vm.readTagSuggestions(
                                                              image_data.value
                                                            )
                                                          }
                                                        ],
                                                        keydown: [
                                                          function($event) {
                                                            if (
                                                              !(
                                                                "button" in
                                                                $event
                                                              ) &&
                                                              _vm._k(
                                                                $event.keyCode,
                                                                "space",
                                                                32,
                                                                $event.key,
                                                                " "
                                                              )
                                                            ) {
                                                              return null
                                                            }
                                                            _vm.createTag(
                                                              image_data.value
                                                            )
                                                          },
                                                          function($event) {
                                                            if (
                                                              !(
                                                                "button" in
                                                                $event
                                                              ) &&
                                                              _vm._k(
                                                                $event.keyCode,
                                                                "tab",
                                                                9,
                                                                $event.key,
                                                                "Tab"
                                                              )
                                                            ) {
                                                              return null
                                                            }
                                                            $event.preventDefault()
                                                            _vm.createTag(
                                                              image_data.value
                                                            )
                                                          },
                                                          function($event) {
                                                            if (
                                                              !(
                                                                "button" in
                                                                $event
                                                              ) &&
                                                              _vm._k(
                                                                $event.keyCode,
                                                                "enter",
                                                                13,
                                                                $event.key,
                                                                "Enter"
                                                              )
                                                            ) {
                                                              return null
                                                            }
                                                            $event.preventDefault()
                                                            _vm.createTag(
                                                              image_data.value
                                                            )
                                                          }
                                                        ]
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        attrs: {
                                                          for:
                                                            image_data.value +
                                                            "_tags"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Choose\n                                                            categories"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "image_tag--suggest z-depth-1 animated d-none  pb-1",
                                                    class: _vm.hideSuggestionClassEvent(
                                                      image_data.value
                                                    ),
                                                    attrs: {
                                                      id:
                                                        image_data.value +
                                                        "_suggest"
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "close fa-close fa",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.closeSuggestion(
                                                            image_data.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.tagSuggest[
                                                        image_data.value
                                                      ],
                                                      function(tag) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            staticClass: "chip",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.createTagNameRecord(
                                                                  image_data.value,
                                                                  tag
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                            " +
                                                                _vm._s(tag) +
                                                                "\n                                                            "
                                                            ),
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-question"
                                                            })
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  _vm._l(
                                                    _vm.tagPills[
                                                      image_data.value
                                                    ],
                                                    function(pill) {
                                                      return _c(
                                                        "div",
                                                        { staticClass: "chip" },
                                                        [
                                                          _vm._v(
                                                            "\n                                                            " +
                                                              _vm._s(pill) +
                                                              "\n                                                            "
                                                          ),
                                                          _c("i", {
                                                            staticClass:
                                                              "close fa fa-times",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.deleteTag(
                                                                  pill,
                                                                  image_data.value
                                                                )
                                                              }
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    }
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-4",
                                  attrs: { "data-ref": "image_preview" }
                                },
                                [
                                  _c("img", {
                                    key: image_data.id,
                                    ref: image_data.id,
                                    refInFor: true,
                                    staticClass: "show_image img-thumbnail",
                                    attrs: {
                                      id: image_data.id + "_image",
                                      index: image_data.id,
                                      src: _vm.readImage(
                                        image_data.image,
                                        image_data.id + "_image"
                                      ),
                                      alt: image_data.value
                                    }
                                  })
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("hr")
                          ])
                        })
                      )
                    ]),
                    _vm._v(" "),
                    _c("ul", { staticClass: "list-group" }, [
                      _c(
                        "li",
                        {
                          staticClass:
                            "list-group-item d-flex justify-content-between align-items-center"
                        },
                        [
                          _vm._v(
                            "\n                            Total files\n                            "
                          ),
                          _c(
                            "span",
                            { staticClass: "badge badge-primary badge-pill" },
                            [_vm._v(_vm._s(_vm.itemsAdded))]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass:
                            "list-group-item d-flex justify-content-between align-items-center"
                        },
                        [
                          _vm._v(
                            "\n                            Total upload size\n                            "
                          ),
                          _c(
                            "span",
                            { staticClass: "badge badge-primary badge-pill" },
                            [_vm._v(_vm._s(_vm.itemsTotalSize))]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isLoaderVisible
                      ? _c("div", { staticClass: "loader" }, [
                          _c("div", { staticClass: "loaderImg" })
                        ])
                      : _vm._e()
                  ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-black",
                    attrs: {
                      type: "submit",
                      disabled:
                        _vm.itemsAdded < _vm.minItems ||
                        _vm.itemsAdded > _vm.maxItems
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-thumbs-o-up mr-1" }),
                    _vm._v(
                      "\n                        Upload\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-default",
                    attrs: { type: "button" },
                    on: { click: _vm.removeItems }
                  },
                  [
                    _c("i", { staticClass: "fa fa-trash mr-1" }),
                    _vm._v("Cancel\n                    ")
                  ]
                )
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm.successMsg !== ""
                ? _c("div", { staticClass: "successMsg" }, [
                    _vm._v(_vm._s(_vm.successMsg))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.errorMsg !== ""
                ? _c("div", { staticClass: "errorMsg" }, [
                    _vm._v("An error has occurred:"),
                    _c("br"),
                    _vm._v(_vm._s(_vm.errorMsg))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.itemsAdded && _vm.itemsAdded < _vm.minItems
                ? _c("div", { staticClass: "errorMsg" }, [
                    _vm._v(
                      "Minimum " +
                        _vm._s(_vm.minItems) +
                        " files need to\n                    be added to uploader. Please remove the files and try again.\n                "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.itemsAdded && _vm.itemsAdded > _vm.maxItems
                ? _c("div", { staticClass: "errorMsg" }, [
                    _vm._v(
                      "A maximum of " +
                        _vm._s(_vm.maxItems) +
                        " files can\n                    be uploaded each time. Please remove the files and try again.\n                "
                    )
                  ])
                : _vm._e()
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "alert alert-info alert-dismissible fade show",
        attrs: { role: "alert" }
      },
      [
        _c(
          "button",
          {
            staticClass: "close",
            attrs: {
              type: "button",
              "data-dismiss": "alert",
              "aria-label": "Close"
            }
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        ),
        _vm._v(
          "\n            First image added is the main image and used in banners. Others will be used to add more content to the\n            page\n            "
        ),
        _c("p", { staticClass: "font-italic font-weight-bold" }, [
          _vm._v(
            "\n                Images must have the correct aspect ratio to enforce consistency on the client layout. "
          ),
          _c("br"),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href:
                  "https://eventsupportteam.atlassian.net/wiki/spaces/DS/pages/567934977/Create+an+image+with+correct+aspect+ratio"
              }
            },
            [_vm._v("See Here\n                to learn how to do it")]
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "text-danger alert alert-danger",
        attrs: { role: "alert" }
      },
      [
        _c("h3", { staticClass: "px-0" }, [
          _vm._v("Image Aspect Ratio not 16:9")
        ]),
        _vm._v(" "),
        _c("p", {}, [
          _c("span", { staticClass: "d-block" }, [
            _vm._v("Aspect ratio must be 16:9 e.g 1920x1080 pixels")
          ])
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Correct the image file aspect ratio first before attempting\n                                                        to upload it see\n                                                        "
          ),
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href:
                  "https://eventsupportteam.atlassian.net/wiki/spaces/DS/pages/567934977/Create+an+image+with+correct+aspect+ratio"
              }
            },
            [
              _vm._v(
                "Here\n                                                            to learn how to do it"
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "font-weight-bold" }, [
          _vm._v("This image will not be uploaded")
        ])
      ]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c3e08ae", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c3e08ae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/forms/image/ImageUploader.vue
// module id = 314
// module chunks = 0